export default __webpack_public_path__ + "static/media/cattle.c0b0b6de.jpg";